import { render, staticRenderFns } from "./resourcesPop.vue?vue&type=template&id=051df978&scoped=true&"
import script from "./resourcesPop.vue?vue&type=script&lang=js&"
export * from "./resourcesPop.vue?vue&type=script&lang=js&"
import style0 from "./resourcesPop.vue?vue&type=style&index=0&id=051df978&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051df978",
  null
  
)

export default component.exports